import { config } from './utils';
import { getItem, removeItem } from './localStorage';

let isClearing = false;

export const isStaleAuthClearInProgress = () => isClearing;

const readJwtSubject = (token: string | null): string | null => {
  if (!token) {
    return null;
  }
  try {
    const payloadPart = token.split('.')[1];
    if (!payloadPart) {
      return null;
    }
    const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(window.atob(normalized));
    return (
      payload?.sub ||
      payload?.userId ||
      payload?.id ||
      null
    );
  } catch {
    return null;
  }
};

/**
 * Clear persisted auth and bounce to login (once).
 * Used when a previously logged-in user was deleted / no longer exists.
 */
export const clearStaleAuthSession = () => {
  if (isClearing || typeof window === 'undefined') {
    return;
  }
  isClearing = true;
  try {
    localStorage.removeItem(config.AUTH_KEY);
    localStorage.removeItem('feathers-jwt');
    removeItem('info');
    removeItem('c');
  } finally {
    window.location.assign('/login');
  }
};

export const isMissingAuthUserError = (error: any): boolean => {
  const data = error?.response?.data || error?.data || error;
  const message = String(data?.message || error?.message || '');
  const match = message.match(
    /No record found for id ['"]?([0-9a-fA-F-]{36})['"]?/i
  );
  if (!match) {
    return false;
  }

  const missingId = String(match[1]);
  const userInfo = getItem('info');
  if (userInfo?.id && String(userInfo.id) === missingId) {
    return true;
  }

  const token =
    localStorage.getItem(config.AUTH_KEY) ||
    localStorage.getItem('feathers-jwt');
  const jwtSubject = readJwtSubject(token);
  if (jwtSubject && String(jwtSubject) === missingId) {
    return true;
  }

  const url = String(
    error?.config?.url || error?.response?.config?.url || ''
  );
  if (
    token &&
    (/\/authentication/i.test(url) ||
      (jwtSubject && url.includes(jwtSubject)))
  ) {
    return true;
  }

  return false;
};
